import { render, staticRenderFns } from "./WolkPrivateDataAlert.vue?vue&type=template&id=85d18a32&"
import script from "./WolkPrivateDataAlert.vue?vue&type=script&lang=js&"
export * from "./WolkPrivateDataAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
